import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "output"]
  static values = { maximum: Number }

  connect() {
    this.update()
  }

  update() {
    const count = this.inputTarget.value.length
    const overMaximum = count > this.maximumValue

    this.outputTarget.textContent = `${count} / ${this.maximumValue}`
    this.outputTarget.setAttribute(
      "aria-label",
      `${count} of ${this.maximumValue} characters used`
    )
    this.outputTarget.classList.toggle("text-gray-500", !overMaximum)
    this.outputTarget.classList.toggle("text-red-700", overMaximum)
  }
}
